import { render, staticRenderFns } from "./PublishEvents.vue?vue&type=template&id=7f96b5ac&scoped=true"
import script from "./PublishEvents.vue?vue&type=script&lang=js"
export * from "./PublishEvents.vue?vue&type=script&lang=js"
import style0 from "./PublishEvents.vue?vue&type=style&index=0&id=7f96b5ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f96b5ac",
  null
  
)

export default component.exports